<script setup lang="ts">
withDefaults(defineProps<{ variant?: 'default' | 'accent' }>(), {
  variant: 'default',
});
</script>

<template>
  <span :class="['chip', `chip--${variant}`]">
    <slot />
  </span>
</template>

<style scoped>
.chip {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-1);
  padding: 4px 10px;
  border-radius: var(--r-sm);
  font-size: var(--fs-sm);
  font-weight: 500;
}
.chip--default { background: var(--bg-overlay); color: var(--text-secondary); }
.chip--accent  { background: var(--accent-soft); color: var(--accent); }
</style>
